import { Box, Container, Typography, Paper, Button } from '@mui/material';
import { Link } from 'react-router';
import { useTranslation } from 'react-i18next';
import { ROUTES } from '../config/constants';
import { SEO } from '../components/SEO';

export const TermsOfService = () => {
  const { t } = useTranslation('terms');
  
  return (
    <>
      <SEO 
        title={t('title')}
        description={t('seoDescription')}
        keywords={t('seoKeywords')}
      />
      <Box
        sx={{
          minHeight: '100vh',
          background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
          py: 8,
        }}
      >
        <Container maxWidth="md">
          <Paper elevation={3} sx={{ p: 4 }}>
            <Typography variant="h3" component="h1" gutterBottom fontWeight="bold">
              {t('title')}
            </Typography>
            <Typography variant="body2" color="text.secondary" gutterBottom mb={4}>
              {t('lastUpdated')}
            </Typography>

            <Typography variant="h5" gutterBottom mt={4}>
              {t('sections.acceptance.title')}
            </Typography>
            <Typography variant="body1" paragraph>
              {t('sections.acceptance.content')}
            </Typography>

            <Typography variant="h5" gutterBottom mt={4}>
              {t('sections.description.title')}
            </Typography>
            <Typography variant="body1" paragraph>
              {t('sections.description.content')}
            </Typography>

            <Typography variant="h5" gutterBottom mt={4}>
              {t('sections.accounts.title')}
            </Typography>
            <Typography variant="body1" paragraph>
              {t('sections.accounts.content')}
            </Typography>

            <Typography variant="h5" gutterBottom mt={4}>
              {t('sections.payments.title')}
            </Typography>
            <Typography variant="body1" paragraph>
              {t('sections.payments.content')}
            </Typography>

            <Typography variant="h5" gutterBottom mt={4}>
              {t('sections.transformativeUse.title')}
            </Typography>
            <Typography variant="body1" paragraph>
              {t('sections.transformativeUse.content')}
            </Typography>

            <Typography variant="h5" gutterBottom mt={4}>
              {t('sections.sourcing.title')}
            </Typography>
            <Typography variant="body1" paragraph>
              {t('sections.sourcing.content')}
            </Typography>

            <Typography variant="h5" gutterBottom mt={4}>
              {t('sections.transientProcessing.title')}
            </Typography>
            <Typography variant="body1" paragraph>
              {t('sections.transientProcessing.content')}
            </Typography>

            <Typography variant="h5" gutterBottom mt={4}>
              {t('sections.marketImpact.title')}
            </Typography>
            <Typography variant="body1" paragraph>
              {t('sections.marketImpact.content')}
            </Typography>

            <Typography variant="h5" gutterBottom mt={4}>
              {t('sections.conduct.title')}
            </Typography>
            <Typography variant="body1" paragraph>
              {t('sections.conduct.content')}
            </Typography>

            <Typography variant="h5" gutterBottom mt={4}>
              {t('sections.intellectualProperty.title')}
            </Typography>
            <Typography variant="body1" paragraph>
              {t('sections.intellectualProperty.content')}
            </Typography>

            <Typography variant="h5" gutterBottom mt={4}>
              {t('sections.liability.title')}
            </Typography>
            <Typography variant="body1" paragraph>
              {t('sections.liability.content')}
            </Typography>

            <Typography variant="h5" gutterBottom mt={4}>
              {t('sections.changes.title')}
            </Typography>
            <Typography variant="body1" paragraph>
              {t('sections.changes.content')}
            </Typography>

            <Typography variant="h5" gutterBottom mt={4}>
              {t('sections.termination.title')}
            </Typography>
            <Typography variant="body1" paragraph>
              {t('sections.termination.content')}
            </Typography>

            <Typography variant="h5" gutterBottom mt={4}>
              {t('sections.governing.title')}
            </Typography>
            <Typography variant="body1" paragraph>
              {t('sections.governing.content')}
            </Typography>

            <Typography variant="body1" paragraph mt={4}>
              {t('contactInfo')}{' '}
              <Typography
                component="a"
                href={`mailto:${t('contactEmail')}`}
                sx={{
                  color: 'primary.main',
                  fontWeight: 'bold',
                  textDecoration: 'underline',
                }}
              >
                {t('contactEmail')}
              </Typography>
            </Typography>

            <Box textAlign="center" mt={6}>
              <Button
                component={Link}
                to={ROUTES.HOME}
                variant="contained"
                size="large"
                sx={{ px: 4 }}
              >
                {t('backToHome')}
              </Button>
            </Box>
          </Paper>
        </Container>
      </Box>
    </>
  );
};
